const PointRuleSubTypes = {
   BIRTHDAY: "BIRTHDAY",
   ENROLL: "ENROLL",
   SIGNUP: "SIGNUP",
   GENERAL_SPENDING: "GENERAL"
};

const RuleState = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
};

export { PointRuleSubTypes, RuleState };